import { OpensearchPaginationCursorSchema } from "@redotech/redo-model/tables/table";
import {
  AdvancedFilterDataSchema,
  VALID_PAGE_SIZES,
} from "@redotech/redo-model/views/views";
import { OrderEditSchema } from "@redotech/redo-order-editing-common/order-edit";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const searchOrderEdits = {
  name: "searchOrderEdits" as const,
  input: z.object({
    advancedFiltersData: z.array(AdvancedFilterDataSchema),
    search: z.string().nullish(),
    sort: z
      .object({ key: z.string(), direction: createEnum(["asc", "desc"]) })
      .nullish(),
    pageSize: z
      .number()
      .refine((value) => VALID_PAGE_SIZES.includes(value as any), {
        message: `pageSize must be one of: ${VALID_PAGE_SIZES.join(", ")}`,
      }),
    pageNumber: z.number(),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
  output: z.object({
    orderEdits: z.array(OrderEditSchema),
    opensearchPaginationCursor: OpensearchPaginationCursorSchema.nullish(),
  }),
};

export type SearchOrderEditsInput = z.infer<typeof searchOrderEdits.input>;
